import React, { useEffect, useRef, useState } from "react";
import styles from "./Style.module.css";
import DropdownReason from "../../../DropDown/DropdownReason";
import BorderedButton from "../../../Buttons/BorderedButton";
import PrimaryButton from "../../../Buttons/PrimaryButton";
import { useGlobalContext } from "../../../../Context/GlobalContext";

const ReasonStep = ({ backStep, sendRefundReq, heading, para, action, processing = false, externalError = ""}) => {
	const {setSelectedReason, selectedReason, setSelectedRemark, selectedRemark} = useGlobalContext();
	const [errorMessages, setErrorMessages] = useState("");

	const cancellationReasons = [
		{text: "Pregnancy-Related Condition"},
		{text: "Injury (e.g. Fracture, Sprain)"},
		{text: "Hospitalisation / Medical Emergency"},
		{text: "Doctor's Advice Against Treatment"},
		{text: "COVID-19 Positive / Contagious Illness"},
		{text: "Bereavement (Immediate Family)"},
		{text: "Accident or Sudden Incident"},
		{text: "Others"}
	];

	const voidSaleReasons = [
		{text: "Incorrect amount charged"},
		{text: "Duplicate transaction"},
		{text: "Customer changed mind"},
		{text: "Payment error"},
		{text: "Service unavailable"},
		{text: "Others"}
	];
	const defaultVoidSaleReason = "Incorrect amount charged";

	useEffect(() => {
		if (action === "voidSale") {
			setSelectedReason(defaultVoidSaleReason);
			setSelectedRemark("");
		}
	}, [action, setSelectedReason, setSelectedRemark]);

	const selectReason = (selected) => {
		if (selected === "Select reason") {
			setSelectedReason("");
		} else {
			setSelectedReason(selected)
			setErrorMessages("");
		}
	};

	const textareaRef = useRef(null);
	
	const handleTextareaInput = (e) => {
		const textarea = textareaRef.current;
		if (textarea) {
			textarea.style.height = "auto";
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
		setSelectedRemark(e.target.value);
		setErrorMessages("");
	};

	const handleConfirmRefund = () => {
		if (!selectedReason) {
			setErrorMessages("Please select a reason");
			return;
		}
		// if (selectedReason === "Others" && !selectedRemark) {
		// 	setErrorMessages("Please enter a remark");
		// 	return;
		// }

		setErrorMessages("");
		sendRefundReq();
	};

	// console.log("action", action);
	

	return (
		<div className={`${styles.reasonStep} popup`}>
			<div className="header">
				<h2>{heading}</h2>
				<p>{para}</p>
			</div>	

			<div className="body">
				<div className={styles.reasonCard}>
					<DropdownReason
						key=""
						options={action === 'voidSale' ? voidSaleReasons : cancellationReasons}
						selectedLabel={selectedReason || (action === "voidSale" ? defaultVoidSaleReason : "Select reason")}
						onSelect={selectReason}
						dropdownClass={`${styles.dropdownNoBg} dropdownNoBg`}
						dropdownToggleClass={styles.fullWidth}
						dropdownToggleIconClass={styles.icon}
					/>
				</div>

				{selectedReason === "Others" && (
					<div className={styles.remarkCard}>
						<textarea
							ref={textareaRef}
							value={selectedRemark}
							onChange={handleTextareaInput}
							placeholder="Remark (optional)"
							rows={1}
							style={{ overflow: "hidden", resize: "none", maxHeight: "40vh" }}
						/>
					</div>
				)}
			</div>

			{/* <div className={styles.space}/> */}
			{errorMessages && (
				<div className={`${styles.errorMessageContainer} common-error-message`}>
					{errorMessages}
				</div>
			)}
			{externalError && !errorMessages && (
				<div className={`${styles.errorMessageContainer} common-error-message`}>
					{externalError}
				</div>
			)}

			<div className="footer">
				<BorderedButton 
					text="Back" 
					onClick={backStep}
					disabled={processing}
				/>
				<PrimaryButton
					text={processing ? "Processing..." : "Refund"}
					onClick={handleConfirmRefund}
					disabled={processing}
				/>

			</div>
		</div>
	);
};

export default ReasonStep;
